import type { FaireProductEntity } from "../../entity_types/product";

export const p_wdaw2fta2p: FaireProductEntity = {
  token: "p_wdaw2fta2p",
  type: "product",
  name: "2pcs Gold Daisy Flower Charms 10mm - WHOLESALE CPG274",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/8c500d709e1971012ac47c6bd2f7230665c9124310f2a4901e51bff9fb4d0db3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43f741ae7d4144084063f41e74826fe4adf4068561e201adfcfefba1f6331310.jpeg",
    "https://cdn.faire.com/fastly/c62ff92af9e79c3ad0ee16fb8bf6fcdbd8243503873d047a74423dec70518a1a.jpeg",
  ],
  priceDollars: 2.07,
  description:
    "2 pcs Gold Daisy Flower Little Charm, Spring and Summer Charm, 10mm, Sunshine Summer Charm,WHOLESALE\nMeasurement: 10mm\nMaterial: 18k Gold plated over brass, coated with non tarnishing coat\nHole: 2mm\nListing is for 2 pcs or 10 pcs\nLead, Cadmium and nickel free\nShip From Los Angeles\nOrders that exceeds $35 will enjoy a Free Shipping Service within the US",
  tags: [],
  msrpDollars: 4.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:33:32.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
